import { defineInlineEdit } from "../../../../components/MobileList/inlineEdit";

const phone = { inputMode: "tel", dir: "ltr" };

/**
 * Mirrors the four <Controller> fields in views/contactPerson/form. The list
 * row is a superset of the form, so no detail fetch is needed before the PUT.
 *
 * `created_at` is intentionally absent — it is not part of the form and the
 * backend would reject it.
 */
export default defineInlineEdit({
  api: "contactPerson",
  hydrate: false,
  toPayload: (source) => ({
    name: source.name ?? "",
    mobile_1: source.mobile_1 ?? "",
    mobile_2: source.mobile_2 ?? "",
    job_title: source.job_title ?? "",
  }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
    mobile_1: {
      label: "الهاتف الأول",
      type: "text",
      required: true,
      inputProps: phone,
    },
    mobile_2: { label: "الهاتف الثاني", type: "text", inputProps: phone },
    job_title: { label: "المسمى الوظيفي", type: "text" },
  },
});
